import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { navLinks } from '@/mocks/site';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <header className={`fixed inset-x-0 top-0 z-50 h-[60px] md:h-[64px] transition-colors duration-500 ${scrolled && !open ? 'bg-background-50/90 backdrop-blur-sm' : 'bg-transparent'}`}>
      <nav className="relative grid h-full grid-cols-3 items-center px-4 md:px-6" aria-label="Primary">
        <div>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-expanded={open}
            aria-controls="site-menu"
            className="inline-flex items-center gap-2.5 rounded-md bg-background-50 px-3 py-2 font-label text-[11px] uppercase tracking-[0.14em] text-foreground-950 hover:bg-primary-500 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center"><i className={open ? 'ri-close-line' : 'ri-menu-line'} /></span>
            {open ? 'Close' : 'Menu'}
          </button>
        </div>
        <Link to="/" className={`justify-self-center font-heading text-base md:text-lg font-extrabold tracking-[-0.03em] whitespace-nowrap cursor-pointer transition-colors duration-500 ${scrolled || open ? 'text-foreground-950' : 'text-[#F4F3F0]'}`}>
          FORM <span className="text-primary-500">&amp;</span> FEEL
        </Link>
        <Link to="/contact" className={`justify-self-end inline-flex items-center gap-2 rounded-md ${scrolled || open ? 'bg-foreground-950' : 'bg-[#7C6AD6]'} px-3 py-2 font-label text-[11px] uppercase tracking-[0.14em] text-background-50 hover:bg-primary-500 transition-colors whitespace-nowrap cursor-pointer`}>
          <span className="hidden sm:inline">Project inquiry</span>
          <span className="sm:hidden">Inquire</span>
          <span className="w-3 h-3 flex items-center justify-center"><i className="ri-arrow-right-up-line" /></span>
        </Link>
      </nav>

      {open && (
        <div id="site-menu" className="fixed inset-x-0 top-0 -z-10 bg-accent-100 pt-[84px] pb-10 border-b border-foreground-950/15">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 px-4 md:px-6">
            <ul className="md:col-span-8">
              {navLinks.map((l, i) => (
                <li key={l.href} className="border-t border-foreground-950/15">
                  <Link to={l.href} onClick={() => setOpen(false)} className="group flex items-baseline gap-5 py-3 cursor-pointer">
                    <span className="font-label text-[11px] text-secondary-600">0{i + 1}</span>
                    <span className="font-heading text-4xl md:text-6xl font-extrabold tracking-[-0.05em] text-foreground-950 group-hover:text-primary-500 transition-colors">{l.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
            <div className="md:col-span-4 md:pt-4 text-sm leading-relaxed text-foreground-800 max-w-[320px]">
              <p>We concept, design and produce remarkable experiences for people and brands.</p>
              <Link to="/contact" onClick={() => setOpen(false)} className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 whitespace-nowrap cursor-pointer">
                Start a project <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}